import React from 'react';
import './SideBar.scss';
import Avatar from "../../ui/Avatar/Avatar";
import MenuButton from "../../ui/MenuButton/MenuButton";
import {useProfileStore} from "../../../store/profile/pofile.store";
import {useNavigate} from "react-router-dom";
import {X, Menu, MessagesSquare, Settings, Plus, Sparkles} from 'lucide-react'


interface SideBarProps {
    variant: 'mobile' | 'desktop';
    children: React.JSX.Element;
    pageTitle: string;
}

const navButtons = [
    {
        title: 'Chats',
        icon: <MessagesSquare size={20}/>,
        link: '/',
    },
    {
        title: 'Settings',
        icon: <Settings size={20}/>,
        link: '/settings',
    }
];

const SideBar = ({children, pageTitle}: SideBarProps) => {

    const [sideBarMenu, setSideBarMenu] = React.useState(false);
    const {user}: any = useProfileStore()
    const navigate = useNavigate();
    const plan = user?.plan;
    const usagePercent = plan?.limits?.messagesPerMonth
        ? Math.min(100, Math.round(plan.usage.messagesSent / plan.limits.messagesPerMonth * 100))
        : 0;

    const closeMenu = () => setSideBarMenu(false);

    return (
        <div className="Layout">
            <aside className={`SideBar ${sideBarMenu ? 'ActiveSideBar' : ''}`}>
                <div className="SideBar__brand">
                    <div className="icon-tile icon-tile--gradient"><Sparkles size={18}/></div>
                    <span>Soulify</span>
                    <button type="button" className="icon-button SideBar__close" aria-label="Close menu"
                            onClick={closeMenu}>
                        <X size={20}/>
                    </button>
                </div>

                <button type="button" className="SideBar__create" onClick={() => {
                    closeMenu();
                    navigate('/create-new-chat');
                }}>
                    <Plus size={18}/> New chat
                </button>

                <nav className="SideBar__nav">
                    {
                        navButtons.map((nav) => (
                            <MenuButton key={nav.title} link={nav.link} title={nav.title} onClick={closeMenu}>
                                {nav.icon}
                            </MenuButton>
                        ))
                    }
                </nav>

                {
                    user?.name && <button type="button" className="SideBar__user" onClick={() => {
                        closeMenu();
                        navigate('/settings');
                    }}>
                        <Avatar type={'name'} image={user.name}/>
                        <div className="SideBar__userInfo">
                            <span className="SideBar__userName">{user.name}</span>
                            {
                                plan && <>
                                    <span className="SideBar__userPlan">
                                        {plan.name} · {plan.usage.messagesSent}/{plan.limits.messagesPerMonth} messages
                                    </span>
                                    <span className="SideBar__usageBar">
                                        <span style={{width: `${usagePercent}%`}}/>
                                    </span>
                                </>
                            }
                        </div>
                    </button>
                }
            </aside>

            {
                sideBarMenu ? <div onClick={closeMenu} className="SideBar__blur"></div> : ''
            }

            <main className="Layout__right">
                <header className="Layout__right-title">
                    <button type="button" className="icon-button SideBar__burger" aria-label="Open menu"
                            onClick={() => setSideBarMenu(true)}>
                        <Menu size={22}/>
                    </button>
                    <h2>{pageTitle}</h2>
                </header>
                {children}
            </main>
        </div>
    );
};

export default SideBar;
